import React from "react"

import OrganisationListItem from "./OrganisationListItem"
import UserListItem from "./UserListItem"
import CommunityListItem from "./CommunityListItem"

const PermissionHolderListItem = props => {
    const onRemove = props.can_remove && props.onRemove
    if (props.labels) {
        if (props.labels.indexOf("User") !== -1)
            return (
                <UserListItem
                    {...props}
                    labels={["User"]}
                    onRemove={onRemove}
                />
            )
        else if (
            props.labels.indexOf("Organisation") !== -1 ||
            props.labels.indexOf("Organization") !== -1
        )
            return (
                <OrganisationListItem
                    {...props}
                    onClick={props.onChecked}
                    shouldDisplayCheckmark={true}
                    labels={["Organization"]}
                    onRemove={onRemove}
                />
            )
        else return <CommunityListItem {...props} onRemove={onRemove} />
    } else {
        switch (props.label) {
            case "User":
                return <UserListItem {...props} onRemove={onRemove} />
            case "Organisation":
            case "Organization":
                return (
                    <OrganisationListItem
                        {...props}
                        labels={["Organization"]}
                        onRemove={onRemove}
                    />
                )
            default:
                return <CommunityListItem {...props} onRemove={onRemove} />
        }
    }
}

export default PermissionHolderListItem
